// extracted by mini-css-extract-plugin
module.exports = {"list":"list--270eW","selected":"selected--3q5Bx"};